export default class CarrierSearchSerializer {
  static serialize(data) {
    return data;
  }

  static deSerialize(data) {
    return {
      ...data,
      active: data.activeCarrier,
      id: data.carrierId,
      mcNumber: data.mcNumber,
      carrierName: data.carrierName,
      modeServices: data.modeServices,
      radius: Math.round(data.radius),
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      phoneNumber: data.phoneNumber,
    };
  }
}